var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownArrowDisabledIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 20.243,
    viewBox: "0 0 13 20.243",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-round-up",
    "data-name": "Icon ionic-ios-arrow-round-up",
    d: "M24,20.792a.862.862,0,0,0-1.246-.007L18.63,25.053V8.789a.881.881,0,1,0-1.76,0V25.053l-4.123-4.275a.868.868,0,0,0-1.246.007.935.935,0,0,0,.007,1.287l5.619,5.794h0a.986.986,0,0,0,.278.19.813.813,0,0,0,.339.07.866.866,0,0,0,.616-.26l5.619-5.794A.92.92,0,0,0,24,20.792Z",
    transform: "translate(-11.247 -7.882)",
    fill: "#bfbfbf"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowDisabledIcon);
export default __webpack_public_path__ + "static/media/down-arrow-disabled-icon.9ad438c8.svg";
export { ForwardRef as ReactComponent };